import { setLocalStorage, getLocalStorage } from '.';

/**
 * List of notification types available in local storage.
 * Each key should follow pattern of nested object to avoid duplication.
 * E.g. ldt.notifications.features.savedEvents.
 */
export const notifications = {
  features: {
    savedEvents: {
      key: 'ldt.notifications.features.savedEvents',
      value: 'hidden',
    },
  },
};

export const searches = {
  last: {
    key: 'ldt.searches.last',
  },
};

export const location = {
  last: {
    key: 'ldt.location.last',
  },
};

export const recentEventVisits = {
  key: 'ldt.recentEventVisits',
  limit: 12,
};

export const setRecentEventVisits = (eventId) => {
  let recentlyViewedEvents = JSON.parse(getLocalStorage(recentEventVisits.key));
  if (recentlyViewedEvents && recentlyViewedEvents.length) {
    const indexOfSameEvent = recentlyViewedEvents.indexOf(eventId);
    if (indexOfSameEvent >= 0) {
      recentlyViewedEvents.splice(indexOfSameEvent, 1);
      recentlyViewedEvents = [eventId].concat(recentlyViewedEvents);
    } else {
      if (recentlyViewedEvents.length >= recentEventVisits.limit) {
        recentlyViewedEvents.splice(-1, 1);
      }
      recentlyViewedEvents = [eventId].concat(recentlyViewedEvents);
    }
  } else {
    recentlyViewedEvents = [eventId];
  }
  setLocalStorage(recentEventVisits.key, JSON.stringify(recentlyViewedEvents));
};

const ldt = {
  notifications,
  searches,
  recentEventVisits,
};

export default ldt;



// WEBPACK FOOTER //
// ./app/src/utils/localStorage.js